export default __webpack_public_path__ + "static/media/aeroland-button-app-store.a4fc40d7.webp";